document.addEventListener('DOMContentLoaded',()=>{
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}})
  },{threshold:.08});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  const videos=document.querySelectorAll('.b4-video');
  const vio=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      const v=e.target;
      const btn=v.closest('.video-wrap')?.querySelector('.video-control');
      if(e.isIntersecting){ v.play().then(()=>{if(btn)btn.textContent='Ⅱ'}).catch(()=>{}); }
      else { v.pause(); if(btn)btn.textContent='▶'; }
    });
  },{threshold:.35,rootMargin:'0px 0px -5% 0px'});
  videos.forEach(v=>{
    vio.observe(v);
    const btn=v.closest('.video-wrap')?.querySelector('.video-control');
    btn?.addEventListener('click',()=>{
      if(v.paused){v.play().catch(()=>{});btn.textContent='Ⅱ'}else{v.pause();btn.textContent='▶'}
    });
    v.addEventListener('play',()=>{if(btn)btn.textContent='Ⅱ'});
    v.addEventListener('pause',()=>{if(btn)btn.textContent='▶'});
  });
});